export default __webpack_public_path__ + "static/media/cardActivationhelpHighlight@2x.e853a8b3.png";